import { MAX_UPLOAD_MB } from '@painpal/contracts';
import { Upload } from 'lucide-react';
import { useState } from 'react';
import { filesOf } from './uploadQueue';
import styles from './upload.module.css';

export function DropZone({ onFiles }: { onFiles: (files: File[]) => void }) {
  const [over, setOver] = useState(false);
  function take(files: File[]): void {
    if (files.length > 0) onFiles(files);
  }
  return (
    <label
      className={styles.zone} data-over={over}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); take(filesOf(e.dataTransfer.files)); }}
    >
      <Upload size={30} aria-hidden="true" />
      <span className={styles.zoneTitle}>
        <span className={styles.desktopOnly}>DROP .FIT FILES</span>
        <span className={styles.phoneOnly}>CHOOSE .FIT FILES</span>
      </span>
      <span className={styles.zoneSub}>{`GARMIN · WAHOO · ZWIFT · ${MAX_UPLOAD_MB} MB MAX`}<span className={styles.desktopOnly}> · OR CLICK</span></span>
      <input
        className="sr-only" type="file" accept=".fit" multiple aria-label="Choose .FIT files"
        onChange={(e) => { take(filesOf(e.currentTarget.files)); e.currentTarget.value = ''; }}
      />
    </label>
  );
}
